import React from "react";

const AboutScreen = () => {
  return <div>AboutScreen</div>;
};

export default AboutScreen;
